export default __webpack_public_path__ + "static/media/0xe6469ba6d2fd6130788e0ea9c0a0515900563b59.71311ed0.webp";